import { render } from "./all-purchases.vue?vue&type=template&id=33e92096&scoped=true"
import script from "./all-purchases.vue?vue&type=script&lang=js"
export * from "./all-purchases.vue?vue&type=script&lang=js"

import "./all-purchases.vue?vue&type=style&index=0&id=33e92096&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e92096"]])

export default __exports__